import { render, staticRenderFns } from "./drawPrize.vue?vue&type=template&id=dd4689d4&scoped=true"
import script from "./drawPrize.vue?vue&type=script&lang=js"
export * from "./drawPrize.vue?vue&type=script&lang=js"
import style0 from "./drawPrize.vue?vue&type=style&index=0&id=dd4689d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4689d4",
  null
  
)

export default component.exports